import { DataTable, DataTableColumnDef } from "@shared/EDS/components/DataTable/DataTable";
import { KapiInstanceMetadata } from "@opstel/query/models/kapiInstanceMetadata";
import { DATETIME_FORMAT, DATETIME_FORMAT_NO_SECONDS } from "@shared/common/utils/luxonHelpers";

const columns: DataTableColumnDef<KapiInstanceMetadata>[] = [
  {
    id: "createdAt",
    header: "Klaargezet op",
    accessorKey: "createdAt",
    cell: ({ row }) => row.original.createdAt.toFormat(DATETIME_FORMAT),
    enableSorting: true,
    size: 320,
  },
  {
    id: "id",
    header: "Scenario",
    accessorKey: "scenario",
    cell: ({ row }) =>
      `${row.original.scenarioStart.toFormat(DATETIME_FORMAT_NO_SECONDS)} t/m ${row.original.scenarioEnd.toFormat(DATETIME_FORMAT_NO_SECONDS)}`,
    enableSorting: true,
    sortFn: (a, b) =>
      a.original.scenarioInterval.toISO().localeCompare(b.original.scenarioInterval.toISO()),
  },
  {
    id: "scenario",
    header: "",
    accessorKey: "identifier",
    enableSorting: false,
    cell(props) {
      return (
        <div style={{ width: "25px" }}>
          <tractie-button
            level="tertiary"
            icon-only
            aria-label={`open-identifier-by-id-${props.row.original.instanceName}`}
          >
            <tractie-icon name="chevron-right" />
          </tractie-button>
        </div>
      );
    },
  },
];

interface InstanceListProps {
  readonly instances: KapiInstanceMetadata[] | null;
  readonly openInstance: (instanceId: string) => void;
  readonly isLoading?: boolean;
}

export function InstanceList({
  instances,
  openInstance,
  isLoading = false,
}: InstanceListProps): React.JSX.Element {
  return (
    <DataTable
      columns={columns}
      data={instances ?? []}
      defaultSort={[{ id: "createdAt", desc: true }]}
      isLoading={isLoading}
      options={{
        loadingMessage: "Plannen worden opgehaald",
        emptyMessage:
          instances === null
            ? "Selecteer een knoop om plannen te bekijken"
            : "Geen plannen gevonden voor deze knoop",
        rowClick: (row) => openInstance(row.original.instanceName),
        isRowInteractive: () => true,
      }}
    />
  );
}
